import React from 'react';
import axios from 'axios';

import Loading from '../Loading'

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';
import { ReactComponent as PlusIcon } from '../../icons/plus.svg';

export default function AddNewCommentToCase({ caseId, access, userId, preType=null, preComment='', onSuccess }) {
    const [isPanelOpen, setIsPanelOpen] = React.useState(false);
    const [type, setType] = React.useState('message');
    const [comment, setComment] = React.useState('');
    const [mailing, setMailing] = React.useState('1');
    const [loading, setLoading] = React.useState(false);
    const [status, setStatus] = React.useState('');

    React.useEffect(() => {
        if (preComment) {
            attachNewComment(preType, preComment, '1');
        }
    }, [preComment]);

    const attachNewComment = (type, comment, mailing) => {
        const token = localStorage.getItem('token');

        setLoading(true);

        const addressee = [];
        if (access) addressee.push('управляющему');
        else addressee.push('аппарату СРО');

        axios.post('/api/add-new-case-comment',
            {
                caseId,
                type,
                comment,
                mailing,
                addressee,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then(() => {
            setType('');
            setComment('');
            setMailing('1');
            setStatus('');
            onSuccess();
            setIsPanelOpen(false);
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Сообщение не добавлено. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        isPanelOpen ? 
            <div className='panel'>
                <div className='panelHeader'>
                    <h3>Отправка нового сообщения</h3>
                    <IconContainer 
                        Icon={XIcon} 
                        onClick={() => {
                            setType('');
                            setComment('');
                            setStatus('');
                            setIsPanelOpen(false);
                        }} 
                        size = '17' 
                        color = 'black' 
                        className = '' 
                    />
                </div>
                <div className='panelMain'>
                    <div className='inputWrapper'>
                        <div>
                            <textarea 
                                cols='10' 
                                rows='10' 
                                value={comment}  
                                onChange={(e) => setComment(e.target.value)}
                                placeholder='Напишите сообщение'
                                minLength='' 
                                maxLength='900' 
                                require=''
                            >
                            </textarea>
                            <p className='description'>{comment.length}/900</p>
                        </div>
                    </div>
                    {userId &&
                    <span style={{display: 'flex', flexDirection: 'column'}}>
                        <label className='legCheckboxWrapper'>
                            <input 
                                type='checkbox'
                                checked={mailing == '1'}
                                onChange={(e) => {setMailing(e.target.checked ? '1' : '0')}}
                            />
                            <a>Оповестить о новом сообщении {access ? 'управляющего' : 'аппарат СРО'}</a>
                        </label>
                        <p className='description' style={{marginLeft: '23px'}}>При выборе данной опции {access ? 'управляющему' : 'аппарату СРО'} придет уведомление</p>
                    </span>}
                </div>
                <div className='panelBottom'>
                    <div>{status}</div>
                    {loading ? 
                        <Loading type='inline' />
                    :
                        <button 
                        type='button' 
                        className='button' 
                        onClick={() => attachNewComment(type, comment, mailing)}
                        disabled={loading}
                        >
                            Отправить
                        </button>
                    }
                </div>
            </div>
        :   <button 
                type='button' 
                className='button miniButton' 
                onClick={() => {setIsPanelOpen(true)}}
            >
                <PlusIcon />
                Добавить новое сообщение
            </button>
    )
}
